import SVGIcon from "@assets/svg";
import { useNavigation } from "@react-navigation/native";
import { mobileSize, tabletSize, } from "@src/utils/screensize-helper";
import React, { useEffect, useState } from "react";
import { Text } from "react-native";
import useStyles from "./styles.css";

const UnawaProduct = ({ color, termsStyle }: any) => {
  const styles = useStyles();
  const isTablet = tabletSize();
  const isMobile = mobileSize();
  const navigation = useNavigation<any>();
  const [ currentYear , setCurrentYear ] = useState("");

  useEffect (() => {
    const year = new Date().getFullYear();
    setCurrentYear(
      year + ""
    );
  }, []);

  return (
    <Text style={[styles.unawaProductStyle, termsStyle, { color }]}>
      <SVGIcon name="UnawaProduct"  width={130} height={15} /> {"\n"}
      {  "© " + currentYear + ". All rights reserved." } {isMobile ? "\n" : ""}
      <Text
        style={styles.copyRightBtnStyle}
        onPress={() => navigation.navigate("terms-condition")}
      >
        Terms & Conditions
      </Text> |
      <Text
        style={styles.copyRightBtnStyle}
        onPress={() => navigation.navigate("privacy-policy")}
      >
        {"  "}
        Privacy Policy
      </Text>
    </Text>
  );
};

export default UnawaProduct;
